function initialsOf(user) {
  if (!user) return '?'
  const name  = user.full_name || user.username || ''
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

export default function UserPill({ user, as: As = 'a', className = '', ...props }) {
  const displayName = user?.full_name || user?.username || ''
  return (
    <As
      className={
        'inline-flex items-center gap-2 pl-1 pr-3 py-1 rounded-full ' +
        'border text-sm font-medium transition-all cursor-pointer select-none ' + className
      }
      style={{ background: 'var(--surface)', borderColor: 'var(--border)', color: 'var(--ink)' }}
      {...props}
    >
      <span
        className="grid place-items-center w-6 h-6 rounded-full text-white text-[10.5px] font-bold tracking-wide flex-shrink-0"
        style={{ background: 'var(--coral)' }}
      >
        {initialsOf(user)}
      </span>
      <span className="hidden sm:inline" style={{ color: 'var(--ink-2)' }}>{displayName}</span>
    </As>
  )
}
